/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';
import { JobPositionExcludingFcmMessageIdFcmTokenWithRelations } from './jobPositionExcludingFcmMessageIdFcmTokenWithRelations';
import { BusinessUnitExcludingFcmMessageIdFcmTokenWithRelations } from './businessUnitExcludingFcmMessageIdFcmTokenWithRelations';
import { VacancyStatusExcludingFcmMessageIdFcmTokenWithRelations } from './vacancyStatusExcludingFcmMessageIdFcmTokenWithRelations';
import { AuthorizedSalaryExcludingFcmMessageIdFcmTokenWithRelations } from './authorizedSalaryExcludingFcmMessageIdFcmTokenWithRelations';
import { ContractTypeExcludingFcmMessageIdFcmTokenWithRelations } from './contractTypeExcludingFcmMessageIdFcmTokenWithRelations';
import { PersonalRequisitionExcludingFcmMessageIdFcmTokenWithRelations } from './personalRequisitionExcludingFcmMessageIdFcmTokenWithRelations';
import { PlaceTypeExcludingFcmMessageIdFcmTokenWithRelations } from './placeTypeExcludingFcmMessageIdFcmTokenWithRelations';
import { SubstitutionTypeExcludingFcmMessageIdFcmTokenWithRelations } from './substitutionTypeExcludingFcmMessageIdFcmTokenWithRelations';
import { RequisitionTypeExcludingFcmMessageIdFcmTokenWithRelations } from './requisitionTypeExcludingFcmMessageIdFcmTokenWithRelations';
import { CompanyExcludingFcmMessageIdFcmTokenWithRelations } from './companyExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<VacancyWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface VacancyExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    jobName: string;
    city: string;
    areaUnitBusiness?: string;
    employeeReplace?: string;
    ammount?: number;
    compensationScheme?: number;
    duration?: string;
    interviewProcess?: number;
    reason?: string;
    comments?: string;
    authorizationDate?: string;
    authorized?: boolean;
    justification?: string;
    candidate?: string;
    deliveryDate?: string;
    dateInitial?: string;
    code?: string;
    level?: string;
    dateCancellation?: string;
    dateDeclined?: string;
    dateSignature?: string;
    dateReactivated?: string;
    companyId?: string;
    requiredById?: number;
    authorizedById?: number;
    vacancyStatusId?: string;
    requisitionPersonalId?: string;
    jobPositionId?: string;
    requisitionTypeId?: string;
    contractTypeId?: string;
    substitutionTypeId?: string;
    placeTypeId?: string;
    authorizedSalaryId?: string;
    businessUnitId?: string;
    company?: CompanyExcludingFcmMessageIdFcmTokenWithRelations;
    requiredBy?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    authorizedBy?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    vacancyStatus?: VacancyStatusExcludingFcmMessageIdFcmTokenWithRelations;
    personalRequisition?: PersonalRequisitionExcludingFcmMessageIdFcmTokenWithRelations;
    jobPosition?: JobPositionExcludingFcmMessageIdFcmTokenWithRelations;
    requisitionType?: RequisitionTypeExcludingFcmMessageIdFcmTokenWithRelations;
    contractType?: ContractTypeExcludingFcmMessageIdFcmTokenWithRelations;
    substitutionType?: SubstitutionTypeExcludingFcmMessageIdFcmTokenWithRelations;
    placeType?: PlaceTypeExcludingFcmMessageIdFcmTokenWithRelations;
    authorizedSalaryType?: AuthorizedSalaryExcludingFcmMessageIdFcmTokenWithRelations;
    businessUnit?: BusinessUnitExcludingFcmMessageIdFcmTokenWithRelations;
}

